import { render, staticRenderFns } from "./SalePauseModal.vue?vue&type=template&id=5bb43c5d&scoped=true"
import script from "./SalePauseModal.vue?vue&type=script&lang=js"
export * from "./SalePauseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb43c5d",
  null
  
)

export default component.exports